import React, { useMemo, useState, useRef, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import UIPopup from '@flatfy/supernova2/src/UIKit/Popup';
import UIMenu from '@flatfy/supernova2/src/UIKit/Menu';
import UIChip from '@flatfy/supernova2/src/UIKit/Chip';
import IconSort from '../../icons/sort.svg';
import { FlatsFiltersContentContext } from '../FlatsFiltersContext';

const EVENT = {
  category: window.eventCategory,
  action: 'sorting',
};

const FlatsFiltersSorting = ({ sort }) => {
  const { searchParams, updateSearchParams, changeTypeformVisibility } = useContext(
    FlatsFiltersContentContext,
  );
  const [opened, setOpened] = useState(false);
  const triggerRef = useRef();
  const menuOptions = useMemo(() => {
    return Object.entries(sort.list)
      .filter(([key]) => key !== sort.order)
      .map(([key, value]) => {
        return {
          event: {
            ...EVENT,
            label: `${key}_click`,
          },
          component: UIMenu.Option,
          content: value.title,
          value: key,
        };
      });
  }, [sort]);

  const handleChange = ({ value }) => {
    updateSearchParams({
      ...searchParams,
      order: value,
    });
    setOpened(false);
  };

  useEffect(() => {
    if (!window.isMobile || !changeTypeformVisibility) return;

    changeTypeformVisibility(!opened);
  }, [changeTypeformVisibility, opened]);

  return (
    <div className="FlatsFiltersSorting">
      <UIChip
        event={{ ...EVENT, label: 'dropdown_click' }}
        onClick={() => setOpened(true)}
        active={opened || sort.order !== 'default'}
        ref={triggerRef}
        type="icon-right"
        icon={<IconSort />}
      >
        {sort.list[sort.order].title}
      </UIChip>
      <UIPopup opened={opened} anchorEl={triggerRef.current} onClose={() => setOpened(false)}>
        <UIMenu onChange={handleChange} options={menuOptions} type="button" />
      </UIPopup>
    </div>
  );
};

FlatsFiltersSorting.propTypes = {
  sort: PropTypes.object,
};

export default FlatsFiltersSorting;
